import { render, staticRenderFns } from "./GradingActions.vue?vue&type=template&id=72803297&scoped=true"
import script from "./GradingActions.vue?vue&type=script&lang=js"
export * from "./GradingActions.vue?vue&type=script&lang=js"
import style0 from "./GradingActions.vue?vue&type=style&index=0&id=72803297&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72803297",
  null
  
)

export default component.exports